import React, {useState} from "react";
import {
  useNavigate,
  Link
} from 'react-router-dom';
import PropTypes from 'prop-types';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';



import FooterPC from './FooterPC';
import FooterMobile from './FooterMobile';
import FooterTablet from './FooterTablet';



const viewportHeight = window.innerHeight;

export default function Footer(props) {



    return (

        <div style={{fontFamily: 'Mohave'}}>

      

              {!isMobileOnly && !isTablet &&
                <BrowserView>
                  <FooterPC/>
               </BrowserView>
             }

              {isMobileOnly &&
        			  <MobileView>
        	         <FooterMobile/>
        			 </MobileView>
        			}

        			{isTablet &&
        			  <TabletView>
        			     <FooterTablet/>
        			  </TabletView>
        			}

        </div>

    );




}
